module.exports = __webpack_public_path__ + "static/media/account-card-slim-vectors.2e84f162.png";